import React from 'react';
import { Grid, TextField, Popper, FormControl, InputLabel, Select as MaterialUISelect, MenuItem } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '../../components/controls/Button';
import { Form } from '../../components/useForm';
import { getDistributorList } from '../../services/distributorService';
import { getCurrentUser } from '../../services/userService';
import { getPurchaseOrderListForDistributor } from '../../services/PurchaseOrder';
import { withRouter } from "react-router";

class SelectDistributorAndPO extends React.Component {
  state = {
    currentUser: null,
    selectedDistributor: '',
    selectedPO: '',
    allDistributors: [],
    allPOs: [],
  };

  getCurrentUserFunc = async () => {
    let user = await getCurrentUser();
    if (user && user.data) {
      this.setState({ currentUser: user.data.body });
      return user.data.body;
    }
    return null;
  };

  async componentDidMount() {
    let fetchedUser = await this.getCurrentUserFunc();

    if (fetchedUser && fetchedUser.user_type !== 'admin') {
      this.setState({
        selectedDistributor: fetchedUser.org_id
      });
      this.fetchPOList(fetchedUser.org_id);
    }

    const allDistributors = await getDistributorList();
    if (allDistributors && allDistributors.data) {
      this.setState({ allDistributors: allDistributors.data.data || [] });
    }
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
  };

  fetchPOList = async (selectedDistributor) => {
    if (!selectedDistributor) {
      this.setState({ allPOs: [] });
      return;
    }
    try {
      let poList = await getPurchaseOrderListForDistributor(selectedDistributor);
      this.setState({ allPOs: poList?.data?.data?.data || [] });
    } catch (err) {
      console.error('Error fetching PO list:', err);
      this.setState({ allPOs: [] });
    }
  };

  render() {
    const isAdmin = this.state.currentUser && this.state.currentUser.user_type === 'admin';

    return (
      <div className="root">
        <Form onSubmit={this.handleFormSubmit}>
          <Grid container spacing={2}>
            {isAdmin && (
              <Grid item xs={12} md={6}>
                <Autocomplete
                  id="distributor-search-autocomplete"
                  options={this.state.allDistributors}
                  PopperComponent={(props) => <Popper {...props} style={{ zIndex: 1500 }} />}
                  getOptionLabel={(option) => {
                    if (!option) return '';
                    return `${option.org_name || ''} -- ${option.sap_distributor_code || ''}`;
                  }}
                  getOptionSelected={(option, value) => option.id == value?.id}
                  value={this.state.allDistributors.find((d) => d.id == this.state.selectedDistributor) || null}
                  onChange={(event, newValue) => {
                    const selectedId = newValue ? newValue.id : '';
                    this.setState({ selectedDistributor: selectedId, selectedPO: '' });
                    if (selectedId) {
                      this.fetchPOList(selectedId);
                    } else {
                      this.setState({ allPOs: [] });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Distributor"
                      variant="outlined"
                      required
                    />
                  )}
                  style={{ width: '100%', marginTop: '8px' }}
                />
              </Grid>
            )}

            <Grid item xs={12} md={isAdmin ? 6 : 12}>
              <Autocomplete
                id="po-search-autocomplete"
                options={this.state.allPOs}
                PopperComponent={(props) => <Popper {...props} style={{ zIndex: 1500 }} />}
                getOptionLabel={(option) => {
                  if (!option) return '';
                  return option.ref_no ? String(option.ref_no) : '';
                }}
                getOptionSelected={(option, value) => option.id == value?.id}
                value={this.state.allPOs.find((po) => po.id == this.state.selectedPO) || null}
                onChange={(event, newValue) => {
                  const selectedId = newValue ? newValue.id : '';
                  this.setState({ selectedPO: selectedId });
                }}
                disabled={this.state.allPOs.length === 0}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Purchase Order"
                    variant="outlined"
                    required
                  />
                )}
                style={{ width: '100%', marginTop: '8px' }}
              />
            </Grid>
          </Grid>

          <Grid container style={{ marginTop: '20px' }}>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <Button
                color="primary"
                variant="contained"
                text="Create Dispatch Plan"
                disabled={!this.state.selectedPO}
                onClick={() => {
                  this.props.history.push(`/create-dispatch-plan/${this.state.selectedPO}`);
                }}
              />
            </Grid>
          </Grid>
        </Form>
      </div>
    );
  }
}

export default withRouter(SelectDistributorAndPO);